import JTextFieldBase from '@atoms/JTextFieldBase';
import { styled } from '@mui/material';

interface IJTextFieldBaseStyledProps {
  attrs: {
    smallSize?: boolean;
  };
}

export const JTextFieldBaseStyled = styled(
  JTextFieldBase,
)<IJTextFieldBaseStyledProps>(({ fullWidth, attrs: { smallSize } }) => ({
  maxWidth: fullWidth ? 'auto' : 265,
  ...(smallSize && {
    maxWidth: 140,
  }),
}));
